import type { SocketFactory } from './ws';

/**
 * WebSocket 建立方式的覆寫點。
 * 正式環境是 `undefined`（用瀏覽器原生 WebSocket）；開發時 `main.tsx` 會動態 import
 * `src/mocks/` 並塞一個假的進來。用動態 import + 這個 holder，mock 程式碼才不會被
 * 打包進正式 bundle。
 */
let override: SocketFactory | null = null;

export function setSocketFactory(factory: SocketFactory | null): void {
  override = factory;
}

export function getSocketFactory(): SocketFactory | undefined {
  return override ?? undefined;
}
